import Vue from 'vue';

export default {
  STORE_PAGE: (state, payload) => {
    Vue.set(state.pages[payload.city], payload.page, payload.content);
  },
  STORE_EXTRA: (state, payload) => {
    Vue.set(state[payload.page], payload.city, payload.content);
  },
  STORE_CHILD: (state, payload) => {
    const childState = state[payload.father][payload.city];
    if (childState.findIndex(child => child.id === payload.id) < 0) {
      childState.push(payload.content);
    }
  },
  LOADING_DATA: (state, payload) => {
    state.loadingData = payload;
  },
  SET_IN_TRANSITION: (state, payload) => {
    state.inTransition = payload;
  },
  SET_MENU_STATE: (state, payload) => {
    state.isMenuOpen = payload;
  },
  STORE_MESSAGE: (state, payload) => {
    const key = `awwwardsConfLastUpdate-${payload.city}`;
    let toDisplay = false;

    if (window.localStorage.getItem(key) !== null
      && JSON.parse(window.localStorage.getItem(key)) < payload.data.timestamp) {
      toDisplay = true;
    }

    window.localStorage.setItem(key, payload.data.timestamp);

    state.message[payload.city] = {
      timestamp: payload.data.timestamp,
      message: payload.data.title,
      toDisplay,
    };
  },
};
